export const SwgyHeaderKeysList = {
    appVersion: "app-version",
    swuid: "swuid",
    versionCode: "version-code",
    deviceId: "deviceid",
    tid: "tid",
    token: "token",
    sid: "sid",
    userAgent: "user-agent",
    agentType: "agent-type",
    lat: "lat",
    lng: "lng",
    device: "device",
    platform: "platform",
    osVersion: "os-version",
    paymentSecretKey: "payment-secret-key",
    userId: "userid",
    analyticsPlatform: "analyticsplatform",
    cartId: "cartid",
    cartAddressId: "cartaddressid",
    addressId: "addressid",
    referrer: "referrer",
    marketPlaceId: "marketplaceId",
    marketplaceBusinessLine: "marketplaceBusinessLine",
    marketplaceCategory: "marketplaceCategory",
    statusBarHeight: "statusbarheight", // this header is used to pass status bar height
    bottomOffset: "bottomoffset", // this header is used to pass bottom offset
    fullScreenStatusBarHeight: "fullscreenstatusbarheight", // this header is used to pass status bar height after A16 migration
    fullScreenBottomOffset: "fullscreenbottomoffset", // this header is used to pass bottom offset after A16 migration
    foodCartHeaders: "foodcartheaders", // this header is used to pass food cart headers
    xCartType: "x-cart-type",
    cartkey: "cartkey",
    showSuccessScreen: "showsuccessscreen",
    orderid: "orderid",
    transactionid: "transactionid",
    paymentamount: "paymentamount",
    planid: "planid",
    cityid: "cityid",
    quantity: "quantity",
    customSuccessScreen: "custom-success-screen",
    accessibilityEnabled: "accessibility-enabled",
    isFromBottomBar: "isfrombottombar",
    xWebCheckoutFlow: "x-web-checkout-flow",
    isSuperUser: "issuperuser",
    referrerAppPlatform: "referrer-app-platform",
    referrerAppVersion: "referrer-app-version",
    cardFingerprint: "card-fingerprint",
    isWebviewAssetsCached: "iswebviewassetscached",
    isWebcachingXpEnabled: "iswebcachingxpenabled",
    isFirstSessionPostDeployment: "isfirstsessionpostdeployment",
    postPaymentRedirectionLink: "postpaymentredirectionlink",
    xChannel: "x-channel", // this header is used when the flow is ran outside of swiggy super app e.g., phonepe switch, legacy dineout, pop & IM standalone apps etc.
    xChannelToken: "x-channel-token", // this header is used for external channel authentication token (e.g., Ixigo)
    xTheme: "x-theme",
    isHeroApiInlineHtmlXp: "isheroapiinlinehtmlxp",
    heroinlinexpconfig: "heroinlinexpconfig",
    cartPagePrefetch: "cartPagePrefetch",
    retainedCartOrderId: "retainedCartOrderId",
    cartSource: "cartSource",
    cartEntry: "cartEntry",
    applicationName: "application_name", // this header is passthrough to analytics click stream. It will be used to identify source app of event
    category: "category", // this header is passthrough to analytics click stream. It will be used to identify categoty of event
    serviceLine: "service-line",
    isR1FA: "isR1FA", //this header is used to find if the address is R1FA or not
    locationContext: "location_context", // this header is used to pass location context in update cart API
    swiggyApplicationNumber: "swiggyapplicationnumber",
    backAction: "back_action", // this header is used for dynamic back navigation handling
    backActionScreenName: "back_action_screen_name", // this header is used to pass screen name for back navigation
    cartType: "cart-type", // this header is used to pass cart type in GPO call for assure
} as const;

export const ANALYTICS_PLATFORM = {
    ANDROID: "an",
    IOS: "ios",
} as const;

export const API_ANALYTICS_PLATFORM = {
    ANDROID: "android",
    IOS: "ios",
    MWEB: "mweb",
    DWEB: "dweb",
};

export const JSON_ENCODED_HEADERS_LIST: string[] = [SwgyHeaderKeysList.foodCartHeaders];

//NOTE: Always add new header(s) in lower case in SwgyHeadersList
export const SwgyHeadersList = Object.values(SwgyHeaderKeysList).map((header) => header.toLowerCase());

export type SwgyHeadersKeys = (typeof SwgyHeadersList)[number];

// TODO: remove this enum once we deprecate the api-server (short lived code)
export enum MARKETPLACE_BUSINESS_LINE {
    REGULAR = "regular",
    POP = "pop",
    EDIT_ORDER = "edit_order",
    SWIGGY_MONEY = "swiggy_money",
    SUBSCRIPTION = "subscription",
    POST_ORDER_TIP = "post_order_tipping",
    SWIGGY_SUPER = "swiggy_super",
    DASH = "dash",
    ASSURE = "assure",
    JUST = "just",
    DINEOUT = "dineout",
    PAY_ON_DELIVERY = "pay_on_delivery",
    HANDPICKED = "handpicked",
    SWIGGY_ONE = "swiggy_one",
}
